import { useSelector } from 'app-redux'
import { useMemo } from 'react'
import { SpeakersView, speakersView } from './model/speakers'
import { usePresenterConsole } from './presenter-console'
import { canChooseSpeakers, useAudioOutputs } from './use-audio-outputs'

export type SpeakersControls = {
	view: SpeakersView
	/** `null` is the system default. */
	onChoose: (deviceId: string | null) => void
	/** Asks the browser for audio access, which reveals the devices' names. */
	onRevealNames: () => void
}

/**
 * What the speaker picker needs: the trainer's choice from the store, the
 * outputs the browser lists, and whether the presentation window could use
 * the choice. `null` in a window that cannot present. It lives above the
 * settings box so that the panel knows the speakers are in trouble while the
 * box is closed.
 */
export const useSpeakersControls = (): SpeakersControls | null => {
	const presenter = usePresenterConsole()
	const chosen = useSelector(state => state.presenter.speakers)
	const { outputs, revealNames } = useAudioOutputs()
	const supported = useMemo(canChooseSpeakers, [])

	if (!presenter) {
		return null
	}
	return {
		view: speakersView({
			supported,
			chosen,
			outputs,
			projectorFellBack: presenter.speakersFellBack,
		}),
		onChoose: presenter.chooseSpeakers,
		onRevealNames: revealNames,
	}
}
